import { Close } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ContentLimitsOfferStage } from '../../domain/Customer/ContentLimits'
import { StripeConnectButton } from '../Adopters/StripeConnectButton'

export const CONTENT_LIMITS_OFFER_TEXTS: Record<ContentLimitsOfferStage, [string, string, string]> = {
  trial: [
    "Vous bénéficiez de 3 mois d'essai sans limite sur les documents et le suivi santé par animal.",
    'Avec le plan gratuit, vous serez ensuite limité à 1 document et 3 entrées de suivi santé par animal.',
    "Pour conserver l'illimité, passez au plan Essentiel ou configurez Stripe Connect.",
  ],
  ended: [
    "Votre période d'essai est terminée.",
    'Le plan gratuit limite chaque fiche animal à 1 document et 3 entrées de suivi santé.',
    'Pour continuer sans limite, passez au plan Essentiel ou configurez Stripe Connect.',
  ],
}

export const OFFERS_PATH = '/association?tab=functionalities'

interface Props {
  stage: ContentLimitsOfferStage | null
  onClose: () => void
}

export const ContentLimitsOfferModal: React.FC<Props> = ({ stage, onClose }) => {
  const navigate = useNavigate()

  if (stage == null) {
    return null
  }

  const [title, limits, callToAction] = CONTENT_LIMITS_OFFER_TEXTS[stage]

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ position: 'relative', pr: 6 }}>
        <Typography variant="h6" fontWeight={800}>
          {title}
        </Typography>
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography>{limits}</Typography>
          <Typography fontWeight={700}>{callToAction}</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
        <Typography
          onClick={onClose}
          sx={{ cursor: 'pointer', color: 'text.secondary', textDecoration: 'underline', fontSize: 14 }}
        >
          Plus tard
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            color="primary"
            sx={{ textTransform: 'none', fontWeight: 700 }}
            onClick={() => {
              onClose()
              navigate(OFFERS_PATH)
            }}
          >
            Voir les offres
          </Button>
          <StripeConnectButton
            variant="contained"
            color="primary"
            fullWidth={false}
            content="Configurer Stripe Connect"
            sx={{ textTransform: 'none', fontWeight: 700 }}
          />
        </Box>
      </DialogActions>
    </Dialog>
  )
}
